import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { Getters, Mutations } from '../../store/manager/helpers'
import { ModalState } from '../../store/manager/state'
import { Dictionary } from 'vue-router/types/router'

@Component({})
export default class ArticlesHeader extends Vue {
  name: 'ArticlesHeader'
  $store: Store<RootState>

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  get query(): Dictionary<string> {
    return this.$route.query
  }

  get selectedCategoryId(): number | null | undefined {
    const categoryId = this.query.category_id

    if (categoryId === 'uncategorized') {
      return null
    }
    return parseInt(categoryId, 10) || undefined
  }

  get totalStorage(): number {
    return Getters.totalStorage(this.$store)
  }

  get usedStorage(): number {
    return Getters.usedStorage(this.$store)
  }

  get isCapacityExcess(): boolean {
    return this.usedStorage / this.totalStorage > 1
  }

  createNewArticle(): void | object {
    if (this.isCapacityExcess) {
      return
    }
    const modalState: ModalState = {
      modalName: 'create-new-article',
      data: {
        category: {
          categoryId: this.selectedCategoryId || null
        }
      }
    }
    Mutations.setModalState(this.$store, modalState)
    return this.$emit('create-new-article')
  }
}
